module.exports = __webpack_public_path__ + "static/media/traducciones.8744368f.png";